import React from 'react';
import { SectionWrapper } from './ui/SectionWrapper';
import { Trophy, CheckCircle2, Target } from 'lucide-react';
const bonuses = [{
  title: 'Checklist de control parental',
  desc: 'Configurá apps y dispositivos paso a paso, sin ser experto.',
  value: '$8.000'
}, {
  title: 'Plan de acción inmediato',
  desc: 'Qué hacer en las primeras 24 horas para proteger a tu hijo.',
  value: '$8.000'
}, {
  title: 'Guía de privacidad y configuración',
  desc: 'Ajustes seguros en redes, juegos y teléfono explicados simple.',
  value: '$8.000'
}, {
  title: 'Frases clave para hablar sin rechazo',
  desc: 'Cómo conversar con tus hijos para que te escuchen de verdad.',
  value: '$8.000'
}, {
  title: 'Detector de señales de alerta',
  desc: 'Reconocé grooming, bullying y adicción antes de que sea tarde.',
  value: '$8.000'
}, {
  title: 'Apps seguras vs. apps a evitar',
  desc: 'Lista por edad de qué permitir y qué bloquear hoy mismo.',
  value: '$8.000'
}];
export function ProductSection() {
  return <>
      <SectionWrapper className="text-center" data-id="element-201">
        <h2 className="text-2xl md:text-4xl font-extrabold mb-8 md:mb-16 text-white" data-id="element-202">
          🧠 ¿Y SI ESTE FUERA EL MOMENTO DE ACTUAR?
        </h2>

        <div className="bg-[#0d3354] border border-sky-400/20 rounded-2xl md:rounded-[2rem] p-5 md:p-12 relative shadow-xl shadow-sky-900/20" data-id="element-203">
          <div className="absolute -top-6 md:-top-8 left-1/2 -translate-x-1/2 bg-sky-500 text-white p-3 md:p-4 rounded-full shadow-lg shadow-sky-500/20" data-id="element-204">
            <Trophy className="w-6 h-6 md:w-8 md:h-8" data-id="element-205" />
          </div>

          <div className="mb-8 md:mb-12 mt-4" data-id="element-206">
            <h3 className="text-sky-400 font-black tracking-widest uppercase mb-2 md:mb-4 text-sm md:text-base" data-id="element-207">
              DIGITALPREMIUM
            </h3>
            <h4 className="text-2xl md:text-5xl font-extrabold text-white mb-3 md:mb-6" data-id="element-208">
              Sistema Completo para Proteger a tus Hijos
            </h4>
            <p className="text-base md:text-xl text-slate-400 font-medium" data-id="element-209">
              50 módulos prácticos, directo al punto, sin relleno
            </p>
          </div>

          <div className="text-left bg-[#0a2c47] rounded-xl md:rounded-2xl p-5 md:p-8 border border-sky-900/40 mb-8 md:mb-12" data-id="element-210">
            <h5 className="text-lg md:text-2xl font-bold mb-5 md:mb-8 flex items-center gap-2 md:gap-3 text-white" data-id="element-211">
              <span className="text-sky-400" data-id="element-212">📘</span> ¿QUÉ INCLUYE?
            </h5>
            <ul className="grid md:grid-cols-2 gap-3 md:gap-4" data-id="element-213">
              {['Cómo funciona el mundo digital de los chicos', 'Cómo operan las redes sociales (explicado simple)', 'Riesgos reales: grooming, bullying, adicción', 'Señales de alerta que tenés que detectar', 'Cómo protegerlos paso a paso', 'Qué hacer HOY en tu casa', 'Cómo hablar con tus hijos sin rechazo', 'Cuándo darles un celular (y cómo hacerlo bien)'].map((item, i) => <li key={i} className="flex items-start gap-2 md:gap-3" data-id="element-214">
                  <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-sky-400 shrink-0" data-id="element-215" />
                  <span className="text-sm md:text-base text-slate-300 font-medium" data-id="element-216">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="bg-sky-400/5 border border-sky-400/20 rounded-xl md:rounded-2xl p-5 md:p-8 text-left max-w-3xl mx-auto" data-id="element-217">
            <h5 className="text-base md:text-xl font-bold mb-4 md:mb-6 flex items-center gap-2 md:gap-3 text-sky-400" data-id="element-218">
              <Target className="w-5 h-5 md:w-6 md:h-6" data-id="element-219" /> RESULTADO
            </h5>
            <div className="space-y-3 md:space-y-4" data-id="element-220">
              <p className="text-base md:text-xl font-bold text-white flex items-center gap-2 md:gap-3" data-id="element-221">
                <span className="text-sky-400" data-id="element-222">👉</span> Entendés lo que antes
                no veías
              </p>
              <p className="text-base md:text-xl font-bold text-white flex items-center gap-2 md:gap-3" data-id="element-223">
                <span className="text-sky-400" data-id="element-224">👉</span> Sabés qué mirar
              </p>
              <p className="text-base md:text-xl font-bold text-white flex items-center gap-2 md:gap-3" data-id="element-225">
                <span className="text-sky-400" data-id="element-226">👉</span> Sabés cómo actuar
              </p>
            </div>
          </div>
        </div>
      </SectionWrapper>

      <SectionWrapper className="bg-[#0a2c47] border-y border-sky-900/40" data-id="element-227">
        <div className="flex flex-col items-center text-center mb-8 md:mb-12" data-id="element-228">
          <div className="text-4xl md:text-5xl mb-3 md:mb-4" aria-hidden="true" data-id="element-229">
            🎁
          </div>
          <h2 className="text-2xl md:text-4xl font-extrabold text-white mb-2 md:mb-3" data-id="element-230">
            6 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-sm md:text-lg text-slate-300 max-w-xl" data-id="element-231">
            Incluidos <span className="font-bold text-sky-400" data-id="element-232">GRATIS</span> por
            tiempo limitado junto a tu acceso.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-5 max-w-5xl mx-auto" data-id="element-233">
          {bonuses.map((bonus, i) => <div key={i} className="bg-[#0d3354] border-2 border-sky-400 rounded-xl md:rounded-2xl p-5 md:p-6 flex flex-col text-left relative shadow-[0_0_24px_rgba(56,189,248,0.12)]" data-id="element-234">
              <span className="inline-flex items-center gap-1.5 self-start bg-sky-500/15 text-sky-400 border border-sky-400/40 text-sm font-bold px-2.5 py-1 rounded-full mb-3" data-id="element-235">
                <span aria-hidden="true" data-id="element-236">🎁</span> BONO #{i + 1}
              </span>
              <h3 className="font-extrabold text-sm md:text-base text-white mb-2 leading-snug" data-id="element-237">
                {bonus.title}
              </h3>
              <p className="text-sm md:text-base text-slate-300 leading-relaxed mb-4" data-id="element-238">
                {bonus.desc}
              </p>
              <div className="mt-auto flex items-center gap-2 pt-3 border-t border-sky-400/30" data-id="element-239">
                <span className="text-sm md:text-base text-slate-400 line-through" data-id="element-240">
                  Valor {bonus.value}
                </span>
                <span className="ml-auto text-sm md:text-base font-extrabold text-sky-400" data-id="element-241">
                  GRATIS
                </span>
              </div>
            </div>)}
        </div>

        <div className="max-w-5xl mx-auto mt-6 md:mt-8" data-id="element-242">
          <div className="bg-[#0d3354] border-2 border-sky-400 rounded-xl md:rounded-2xl p-4 md:p-6 text-center shadow-[0_0_24px_rgba(56,189,248,0.12)]" data-id="element-243">
            <p className="text-base md:text-lg text-slate-300" data-id="element-244">
              Valor total de los bonos:{' '}
              <span className="text-slate-400 line-through font-bold" data-id="element-245">
                $53.000
              </span>
            </p>
            <p className="text-xl md:text-2xl font-extrabold text-white mt-1" data-id="element-246">
              👉 Hoy los recibís <span className="text-sky-400" data-id="element-247">GRATIS</span>
            </p>
          </div>
        </div>
      </SectionWrapper>
    </>;
}